import { FILTER_TYPES } from 'components/FilterPod';
export const STATUS_OPTIONS = [
  {
    label: 'فعال',
    value: true,
  },

  {
    label: 'غیرفعال',
    value: false,
  },
];
const filters = () => [
  {
    title: 'نام بن',
    label: 'نام',
    keyName: 'name',
    query: 'name',
    id: 3432,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {},
  },
  {
    title: 'کد بن شارژ',
    label: 'کد',
    keyName: 'hash',
    query: 'hash',
    id: 3433,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {},
  },
  {
    title: 'حساب تفصیلی',
    label: 'حساب تفصیلی',
    keyName: 'guildCode',
    query: 'guildCode',
    id: 3442,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: [],
    },

  },

  {
    title: 'وضعیت',
    label: 'وضعیت',
    keyName: 'active',
    query: 'active',
    id: 3435,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: STATUS_OPTIONS,
    },
  },
  {
    title: 'وضعیت استفاده',
    label: 'وضعیت استفاده',
    keyName: 'used',
    query: 'used',
    id: 3438,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: [
        {
          label: 'استفاده شده',
          value: 1,
        },
        {
          label: 'استفاده نشده',
          value: 0,
        },
      ],
    },
  },
];

export default filters;
